var map = {
	"./cs.json": 689,
	"./da.json": 690,
	"./de.json": 691,
	"./en.json": 692,
	"./es.json": 693,
	"./fi.json": 694,
	"./fr.json": 695,
	"./it.json": 696,
	"./ja.json": 697,
	"./ko.json": 698,
	"./nb.json": 699,
	"./nl.json": 700,
	"./pl.json": 701,
	"./pt-BR.json": 702,
	"./pt-PT.json": 703,
	"./sv.json": 704,
	"./th.json": 705,
	"./tr.json": 706,
	"./vi.json": 707,
	"./zh-CN.json": 708,
	"./zh-TW.json": 709
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 3);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | DiscountAppComponents-i18n */ 530).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 671;
module.exports = webpackAsyncContext;